import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import error404 from "../../../assets/icon/error404.svg";
import placeholderIcon from "../../../assets/icon/placeholderIcon.png";

export const NoAnyTestAvail = () => {
  return (
    <div className="noTestAssigned">
      <div className="noTestAssigned-img">
        <LazyLoadImage
          placeholderSrc={placeholderIcon}
          alt=""
          effect="blur"
          src={error404}
        />
      </div>
      <h1>Sorry! No tests available</h1>
    </div>
  );
};
